export const DATA = [
  {
    name: { tr: 'İSKELE SİSTEMLERİ', en: 'SCAFFOLDING SYSTEMS' },
    svg: 'iskele-sistemleri.svg',
    link: 'iskele-sistemleri',
    images: ['1', '2', '3'],
    cover: 'cover',
    innerCategory: [
      {
        name: { tr: 'GİK Kamalı Flanşlı İskele Sistemi', en: 'GİK Ring-Lock Scaffolding System' },
        link: 'gik-kamali-flansli-iskele-sistemi',
        images: ['1', '2', '3', '4', '5'],
        text: [
          {
            tr: 'GİK Kamalı Flanşlı İskele Sistemi, özellikle endüstriyel tesisler, yüksek katlı yapılar, bakım ve onarım çalışmaları gibi zorlu koşullarda güvenli ve verimli bir çalışma ortamı sunar.',
            en: 'The GIK Ring-Lock Scaffolding System provides a safe and efficient working environment, in challenging conditions such as especially industrial facilities, high-rise buildings, maintenance, and repair works.'
          },
          {
            tr: 'Bu sistem, TS EN 12810 standardına uygun olarak üretilmiştir ve yüksek dayanıklılığıyla öne çıkar. Dikey elemanlar üzerinde 50 cm aralıklarla konumlandırılmış flanşlar, yatay bağlantıların kurtağzı ve kama mekanizmasıyla kolay ve sağlam bir şekilde sabitlenmesini sağlar. Bu sayede hızlı kurulum, yüksek taşıma kapasitesi ve güvenli çalışma imkanı sunar.',
            en: 'This system is manufactured in compliance with the TS EN 12810 standard and stands out with its high durability. The flanges positioned at 50 cm intervals on the vertical elements allow horizontal connections to be securely and easily fixed using the wedge-lock mechanism. This ensures fast assembly, high load capacity, and safe working conditions.'
          },
          {
            tr: 'GİK Kamalı Flanşlı İskele Sistemi, modüler yapısıyla farklı proje ihtiyaçlarına uyum sağlar ve her türlü inşaat sahasında güvenli bir çözüm sunar.',
            en: 'With its modular structure, the GİK Ring-Lock Scaffolding System adapts to different project requirements and provides a safe solution for all construction sites.'
          }
        ],
        markedText: {
          title: { tr: 'Kullanım Alanları:', en: 'Usage Areas:' },
          items: [
            { tr: '✔ Cephe iskele uygulamaları', en: '✔ Façade scaffolding applications' },
            { tr: '✔ Endüstriyel tesislerde bakım-onarım çalışmaları', en: '✔ Maintenance operations in industrial facilities' },
            { tr: '✔ Yüksek binalarda inşaat ve tadilat projeleri', en: '✔ Construction and renovation projects in high-rise buildings' },
            { tr: '✔ Yat gemi imalat ve bakım onarım çalışmaları', en: '✔ Yacht and ship manufacturing, maintenance, and repair work' }
          ]
        },
        innerCategory: [
          {
            name: { tr: 'Cephe Uygulamaları', en: 'Facade Applications' },
            link: 'cephe-uygulamalari',
            mainImage: 'main.jpg',
            images: ['1', '2', '3', '4', '5', '6', '7'],
            mainText: [
              {
                tr: 'GİK Kamalı Flanşlı İskele Sistemi, modüler parçaları ve çeşitli aksesuarları sayesinde özellikle düz cephesi olmayan yapılarda cephenin her noktasına ulaşım sağlar.',
                en: 'The GIK Ring-Lock Scaffolding System, with its modular components and various accessories, provides access to every point of the facade, especially in structures without a flat facade.'
              }
            ],
            catalog: '',
            generalText: [''],
            generalInformationText: [
              { tr: 'Vinç ile kolay taşınır.', en: 'Easily transported by crane.' },
              { tr: 'Aynı elemanlar ile farklı boy ve genişlikte panolar oluşturulur.', en: 'Panels of various sizes and widths can be created with the same components.' }
            ],
            generalInformationsMainImage: 'main.jpg',
            generalInformationsDetailImage: ['0', '1', '2'],
            technicalDetail: [
              {
                name: { tr: 'ACIBADEM TAKSİM İSTANBUL', en: 'ACIBADEM TAKSIM ISTANBUL' },
                image: '0'
              }
            ],
            projects: [
              {
                name: { tr: 'ACIBADEM TAKSİM İSTANBUL-1', en: 'ACIBADEM TAKSIM ISTANBUL-1' },
                link: 'acibadem-taksim-istanbul-1',
                image: 'acibadem-taksim-istanbul-1'
              }
            ]
          },
          {
            name: { tr: 'Endüstriyel Proje Uygulamaları', en: 'Industrial Project Applications' },
            link: 'endustriyel-proje-uygulamalari',
            mainImage: 'main.jpg',
            images: ['1', '2', '3', '4', '5', '6'],
            mainText: [
              {
                tr: 'GİK Kamalı Flanşlı İskele Sistemi, geniş modüler parça yelpazesi ve aksesuar çeşitliliği ile ulaşılması güç tüm alanlara erişim sağlar.',
                en: 'The GIK Ring-Lock Scaffolding System provides access to all hard-to-reach areas with its wide range of modular components and diverse accessories.'
              }
            ],
            catalog: '',
            generalText: [''],
            generalInformationText: [
              { tr: 'Vinç ile kolay taşınır.', en: 'Easily transported by crane.' },
              { tr: 'Aynı elemanlar ile farklı boy ve genişlikte panolar oluşturulur.', en: 'Panels of various sizes and widths can be created with the same components.' }
            ],
            generalInformationsMainImage: 'main.jpg',
            generalInformationsDetailImage: ['0', '1', '2'],
            technicalDetail: [
              {
                name: { tr: 'ACIBADEM TAKSİM İSTANBUL', en: 'ACIBADEM TAKSIM ISTANBUL' },
                image: '0'
              }
            ],
            projects: [
              {
                name: { tr: 'ACIBADEM TAKSİM İSTANBUL-1', en: 'ACIBADEM TAKSIM ISTANBUL-1' },
                link: 'acibadem-taksim-istanbul-1',
                image: 'acibadem-taksim-istanbul-1'
              }
            ]
          },
          {
            name: { tr: 'Yat - Gemi İmalatı ve Tadilat Proje Uygulamaları', en: 'Yacht - Ship Manufacturing and Renovation Project Applications' },
            link: 'yat-gemi-imalati-ve-tadilat-proje-uygulamalari',
            mainImage: 'main.jpg',
            images: ['1', '2', '3', '4', '5', '6', '7'],
            mainText: [
              {
                tr: 'GİK Kamalı Flanşlı İskele Sistemi, standart parçalara uyumlu çatı parçaları sayesinde 13 metre açıklığa kadar kapalı çalışma alanları oluşturulmasına olanak tanır. Bu sistem, açık alanlarda güvenli ve etkili çalışma koşulları sağlamak için pratik çözümler sunar.',
                en: 'The GIK Ring-Lock Scaffolding System allows the creation of the covered working areas up to 13 meters in span with its roof components compatible with standard parts. This system provides practical solutions to ensure safe and efficient working conditions in open areas.'
              }
            ],
            catalog: '',
            generalText: [''],
            generalInformationText: [
              { tr: 'Vinç ile kolay taşınır.', en: 'Easily transported by crane.' },
              { tr: 'Aynı elemanlar ile farklı boy ve genişlikte panolar oluşturulur.', en: 'Panels of various sizes and widths can be created with the same components.' }
            ],
            generalInformationsMainImage: 'main.jpg',
            generalInformationsDetailImage: ['0', '1', '2'],
            technicalDetail: [
              {
                name: { tr: 'ACIBADEM TAKSİM İSTANBUL', en: 'ACIBADEM TAKSIM ISTANBUL' },
                image: '0'
              }
            ],
            projects: [
              {
                name: { tr: 'ACIBADEM TAKSİM İSTANBUL-1', en: 'ACIBADEM TAKSIM ISTANBUL-1' },
                link: 'acibadem-taksim-istanbul-1',
                image: 'acibadem-taksim-istanbul-1'
              }
            ]
          },
          {
            name: { tr: 'Alt Yapı Projeleri Uygulamaları', en: 'Infrastructure Projects Applications' },
            link: 'alt-yapi-projeleri-uygulamalari',
            mainImage: 'main.jpg',
            images: ['1', '2', '3', '4', '5', '6', '7'],
            mainText: [
              {
                tr: 'GİK Kamalı Flanşlı İskele Sistemi, cıvata gibi bağlantı elemanları gerektirmeyen yapısı sayesinde hızlı ve pratik kurulum imkanı ile zor koşullarda bile çözüm üretilmesini sağlar.',
                en: 'The GİK Ring-Lock Scaffolding System, with its structure that does not require fasteners such as bolts, enables fast and practical assembly, providing solutions even in challenging conditions.'
              }
            ],
            catalog: '',
            generalText: [''],
            generalInformationText: [
              { tr: 'Vinç ile kolay taşınır.', en: 'Easily transported by crane.' },
              { tr: 'Aynı elemanlar ile farklı boy ve genişlikte panolar oluşturulur.', en: 'Panels of various sizes and widths can be created with the same components.' }
            ],
            generalInformationsMainImage: 'main.jpg',
            generalInformationsDetailImage: ['0', '1', '2'],
            technicalDetail: [
              {
                name: { tr: 'ACIBADEM TAKSİM İSTANBUL', en: 'ACIBADEM TAKSIM ISTANBUL' },
                image: '0'
              }
            ],
            projects: [
              {
                name: { tr: 'ACIBADEM TAKSİM İSTANBUL-1', en: 'ACIBADEM TAKSIM ISTANBUL-1' },
                link: 'acibadem-taksim-istanbul-1',
                image: 'acibadem-taksim-istanbul-1'
              }
            ]
          }
        ]
      },
      {
        name: { tr: 'Scaf-fix H Tipi İskele Sistemi', en: 'Scaf-fix H Type Scaffolding System' },
        link: 'scaf-fix-h-tipi-iskele-sistemi',
        images: ['1', '2', '3', '4', '5'],
        text: [
          {
            tr: 'Scaf-fix H Tipi İskele Sistemi, ergonomik tasarımı ile hızlı ve pratik kurulum imkanı sunar. Özellikle düz cepheli ve yüksek katlı projelerde büyük avantaj sağlar. TS EN 12810 standardına uygun olarak üretilen sistem, 80 cm ve 112 cm genişlik seçenekleriyle güvenli çalışma imkanı sunar.',
            en: 'The Scaf-fix H-Type Scaffolding System offers fast and practical assembly with its ergonomic design. It provides a significant advantage, especially in flat-facade and high-rise projects. Manufactured in compliance with the TS EN 12810 standard, the system ensures safe working conditions with width options of 80 cm and 112 cm.'
          }
        ],
        innerCategory: [
          {
            name: { tr: 'Cephe Uygulamaları', en: 'Facade Applications' },
            link: 'cephe-uygulamalari',
            mainImage: 'main.jpg',
            images: ['1', '2', '3', '4', '5', '6'],
            mainText: [
              {
                tr: 'Scaf-fix H Tipi İskele Sistemi, benzersiz tasarımı sayesinde engelsiz çalışma sağlar. Çerçeve alt parçasının çelik kalasların arasına gizlenmesi sayesinde kullanıcılar düz bir çalışma alanında çalışırlar.',
                en: 'The Scaf-fix H-Type Scaffolding System provides unobstructed working thanks to its unique design. Thanks to the frame lower part being hidden between the steel planks, users work in a flat working area.'
              }
            ],
            catalog: '',
            generalText: [''],
            generalInformationText: [
              { tr: 'Vinç ile kolay taşınır.', en: 'Easily transported by crane.' },
              { tr: 'Aynı elemanlar ile farklı boy ve genişlikte panolar oluşturulur.', en: 'Panels of various sizes and widths can be created with the same components.' }
            ],
            generalInformationsMainImage: 'main.jpg',
            generalInformationsDetailImage: ['0', '1', '2'],
            technicalDetail: [
              {
                name: { tr: 'ACIBADEM TAKSİM İSTANBUL', en: 'ACIBADEM TAKSIM ISTANBUL' },
                image: '0'
              }
            ],
            projects: [
              {
                name: { tr: 'ACIBADEM TAKSİM İSTANBUL-1', en: 'ACIBADEM TAKSIM ISTANBUL-1' },
                link: 'acibadem-taksim-istanbul-1',
                image: 'acibadem-taksim-istanbul-1'
              }
            ]
          }
        ]
      },
      {
        name: { tr: 'Mobil İskele Sistemi', en: 'Mobile Scaffolding System' },
        link: 'mobil-iskele-sistemi',
        images: ['1', '2', '3'],
        text: [
          {
            tr: 'Mobil İskele Sistemi, çeşitli ölçü seçenekleri ile kapalı alanlar başta olmak üzere, galeri boşlukları, fabrika inşaatları, endüstriyel tesisler gibi birçok projede güvenli çalışma sağlar.',
            en: 'The Mobile Scaffolding System ensures safe working conditions in various projects, including indoor spaces, atrium voids, factory constructions, and industrial facilities, with its various size options.'
          }
        ]
      },
      {
        name: { tr: 'Şaft Merdiveni Sistemi', en: 'Shaft Ladder System' },
        link: 'saft-merdiveni-sistemi',
        images: ['1', '2', '3'],
        text: [
          {
            tr: 'Şaft Merdiveni Sistemi, çalışma alanlarına güvenli ulaşım sağlamasıyla metro projeleri başta olmak üzere zemin kotunun altındaki tüm çalışma alanlarının vazgeçilmez sistemidir. Taşıma aparatı sayesinde, merdivenin sökülmeden şantiyelerde farklı alanlara taşınması mümkündür.',
            en: 'The Shaft Ladder System is an indispensable system for all work areas below ground level, especially subway projects, as it provides safe access to work areas. Thanks to its transport apparatus, the ladder can be moved to different areas on-site without disassembly.'
          }
        ],
        innerCategory: [
          {
            name: { tr: 'Tip-1 Modeli 1.55x3.05', en: 'Type-1 Model 1.55x3.05' },
            link: 'tip-1-modeli-1-55x3-05',
            mainImage: 'main.jpg',
            images: ['1', '2', '3', '4', '5', '6'],
            mainText: [
              {
                tr: 'Şaft Merdiveni Sistemimizin en küçük ebatlı olan Tip-1 Modeli, çapı 9 m den küçük olan şaftlarda tercih edilmektedir. 65 cm sahanlık, 65 cm merdiven genişliği ile bu model, dar alanlarda maksimum güvenlik ve rahatlık sağlar.',
                en: 'The smallest model of our Shaft Ladder System, Type-1, is preferred for shafts with a diameter of less than 9 meters. With a 65 cm landing and a 65 cm ladder width, this model ensures maximum safety and comfort in confined spaces.'
              }
            ],
            catalog: '',
            generalText: [''],
            generalInformationText: [
              { tr: 'Vinç ile kolay taşınır.', en: 'Easily transported by crane.' },
              { tr: 'Aynı elemanlar ile farklı boy ve genişlikte panolar oluşturulur.', en: 'Panels of various sizes and widths can be created with the same components.' }
            ],
            generalInformationsMainImage: 'main.jpg',
            generalInformationsDetailImage: ['0', '1', '2'],
            technicalDetail: [
              {
                name: { tr: 'ACIBADEM TAKSİM İSTANBUL', en: 'ACIBADEM TAKSIM ISTANBUL' },
                image: '0'
              }
            ],
            projects: [
              {
                name: { tr: 'ACIBADEM TAKSİM İSTANBUL-1', en: 'ACIBADEM TAKSIM ISTANBUL-1' },
                link: 'acibadem-taksim-istanbul-1',
                image: 'acibadem-taksim-istanbul-1'
              }
            ]
          },
          {
            name: { tr: 'Tip-2 Modeli 2.05x3.67', en: 'Type-2 Model 2.05x3.67' },
            link: 'tip-2-modeli-2-05x3-67',
            mainImage: 'main.jpg',
            images: ['1', '2', '4'],
            mainText: [
              {
                tr: 'Şaft Merdiveni Sistemimizin en çok tercih edilen modeli olan Tip-2 nin sahanlık genişliği 89 cm, merdiven genişliği ise 75 cm dir.',
                en: 'The most preferred model of our Shaft Ladder System, Type-2, features a landing width of 89 cm and a ladder width of 75 cm.'
              }
            ],
            catalog: '',
            generalText: [''],
            generalInformationText: [
              { tr: 'Vinç ile kolay taşınır.', en: 'Easily transported by crane.' },
              { tr: 'Aynı elemanlar ile farklı boy ve genişlikte panolar oluşturulur.', en: 'Panels of various sizes and widths can be created with the same components.' }
            ],
            generalInformationsMainImage: 'main.jpg',
            generalInformationsDetailImage: ['0', '1', '2'],
            technicalDetail: [
              {
                name: { tr: 'ACIBADEM TAKSİM İSTANBUL', en: 'ACIBADEM TAKSIM ISTANBUL' },
                image: '0'
              }
            ],
            projects: [
              {
                name: { tr: 'ACIBADEM TAKSİM İSTANBUL-1', en: 'ACIBADEM TAKSIM ISTANBUL-1' },
                link: 'acibadem-taksim-istanbul-1',
                image: 'acibadem-taksim-istanbul-1'
              }
            ]
          },
          {
            name: { tr: 'Tip-3 Modeli 2.35x4.31', en: 'Type-3 Model 2.35x4.31' },
            link: 'tip-3-modeli-2-35x4-31',
            mainImage: 'main.jpg',
            images: ['1', '2', '3', '4', '5', '6', '7', '8'],
            mainText: [
              {
                tr: 'Şaft Merdiveni Sistemimizin en büyük ebatlı modeli olan Tip-3, özellikle 50 m den fazla derinliğe sahip olan şaftlarda tercih edilir. Sahanlık ve merdiven genişliğinin 100 cm olması sayesinde, acil durumlarda sedye geçişi kolaylıkla sağlanır.',
                en: 'The largest model of our Shaft Ladder System, Type-3, is specifically preferred for shafts deeper than 50 meters. With a landing and ladder width of 100 cm, it allows for easy stretcher passage in emergency situations.'
              }
            ],
            catalog: '',
            generalText: [''],
            generalInformationText: [
              { tr: 'Vinç ile kolay taşınır.', en: 'Easily transported by crane.' },
              { tr: 'Aynı elemanlar ile farklı boy ve genişlikte panolar oluşturulur.', en: 'Panels of various sizes and widths can be created with the same components.' }
            ],
            generalInformationsMainImage: 'main.jpg',
            generalInformationsDetailImage: ['0', '1', '2'],
            technicalDetail: [
              {
                name: { tr: 'ACIBADEM TAKSİM İSTANBUL', en: 'ACIBADEM TAKSIM ISTANBUL' },
                image: '0'
              }
            ],
            projects: [
              {
                name: { tr: 'ACIBADEM TAKSİM İSTANBUL-1', en: 'ACIBADEM TAKSIM ISTANBUL-1' },
                link: 'acibadem-taksim-istanbul-1',
                image: 'acibadem-taksim-istanbul-1'
              }
            ]
          }
        ]
      },
      {
        name: { tr: 'Gemici Merdiveni Sistemi', en: 'Ship Staircase System' },
        link: 'gemici-merdiveni-sistemi',
        images: ['1', '2', '3', '4'],
        text: [
          {
            tr: 'Gemici Merdiveni Sistemi, çalışma alanlarına güvenli ulaşım sağlaması için üretilmiş olup, tüm inşaat projelerinin derin temel kazıları ve metro projelerinin şaft kazıları sırasında kullanılır.',
            en: 'The Ship Ladder System is designed to provide safe access to work areas and is used in deep foundation excavations of construction projects and shaft excavations of subway projects.'
          }
        ]
      }
    ]
  },
  {
    name: { tr: 'KALIP SİSTEMLERİ', en: 'FORMWORK SYSTEMS' },
    svg: 'kalip-sistemleri.svg',
    link: 'kalip-sistemleri',
    images: ['1', '2', '3'],
    cover: 'cover',
    innerCategory: [
      {
        name: { tr: 'Sac Yüzeyli Kalıp Sistemi', en: 'Steel Surface Formwork System' },
        link: 'sac-yuzeyli-kalip-sistemi',
        images: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
        text: [
          {
            tr: 'Sac Yüzeyli Kalıp Sistemi, geleneksel kalıp yönteminde hızlı sarfiyatı olan plywoood ve ahşap benzeri malzemeler yerine tamamen ST37 kalite siyah sacdan üretilmektedir. Bu sayede sarfiyatı düşük ve uzun ömürlüdür. MÖ50, MS53 ve MS63 gibi üç farklı üretim seçeneğine sahiptir. MÖ50 ve MS53 seçenekleri beton kesitlerinin daha küçük olduğu projelerde tercih edilirken, MS63 seçeneği beton kesitlerinin arttığı projelerde tercih edilmektedir.',
            en: 'The Steel Surface Formwork System is manufactured entirely from ST37 (S235JR) grade sheet metal instead of plywood and wood-like materials that consume quickly in the traditional formwork method. Thus, its consumption is low and it is long-lasting material. It has three different production options such as MÖ50, MS53 and MS63. While MÖ50 and MS53 options are preferred in projects where concrete sections are smaller, MS63 option is preferred in projects where concrete sections are increased.'
          },
          {
            tr: 'Bu kalıp sistemi, villa ve konut projelerinin yanı sıra yüksek katlı binalar, sanayi yapıları gibi büyük ölçekli projelerde de güvenle kullanılabilmektedir. Hem elle hem de vinçle taşınabilir olması, şantiyelerde işçilik tasarrufu sağlar.',
            en: 'This formwork system can be used safely in large-scale projects such as high-rise buildings, industrial structures as well as villa and residential projects. Being portable both by hand and by crane provides labor savings in construction sites.'
          }
        ],
        markedText: {
          title: { tr: 'Öne Çıkan Özellikler:', en: 'Key Features:' },
          items: [
            { tr: '✔ Farklı montaj seçenekleri: Paneller, yan yana ve üst üste montaj edilebilir, böylece farklı projelere ve ölçülere kolayca uyum sağlar.', en: '✔ Different assembly options: Panels can be assembled side by side and on top of each other, thus easily adapting to different projects and sizes.' },
            { tr: '✔ Kolay montaj: Paneller, pim&kama ve klips sistemi ile güvenli ve hızlı bir şekilde montajlanır.', en: '✔ Easy assembly: Panels are assembled safely and quickly with pin&wedge and clip system.' },
            { tr: '✔ Uzun ömürlü kullanım: Sac yüzeyli paneller, uzun yıllar dayanıklı olup, şantiyelerde verimli bir çözüm sunar.', en: '✔ Long-lasting use: Steel surface panels are durable for many years and provide an efficient solution in construction sites.' },
            { tr: '✔ Sac Yüzeyli Kalıp Sistemi, inşaat projelerinde sağlamlığı, ölçülerdeki esnekliği ve hızı sayesinde kullanıcılarına zaman ve maliyet tasarrufu sağlar.', en: '✔ The Steel Surface Formwork System saves time and cost for its users thanks to its durability, flexibility in dimensions and speed in construction projects.' }
          ]
        }
      },
      {
        name: { tr: 'MO-KA Light Plywood Yüzeyli Kalıp Sistemi', en: 'MO-KA Light Plywood Surface Formwork System' },
        link: 'mo-ka-light-plywood-yuzeyli-kalip-sistemi',
        images: ['1', '2', '3', '4'],
        text: [
          {
            tr: 'MO-KA Light Plywood Yüzeyli Kalıp Sistemi, hafifliği ve modüler yapısı ile öne çıkar. 75 mm panel kalınlığı bulunan MO-KA Light tamamen galvanizli üretilmekte olup, yüzeyinde 12 mm Plywood bulunmaktadır. Bu sistem, elle veya vinçle taşınabilir olması sayesinde şantiyelerde hızlı kurulum ve kolay taşınabilirlik sağlar. Özel bağlantı aparatları sayesinde paneller, hem dikey hem de yatay olarak kolayca montajlanabilir. Sistem farklı projelere de maksimum uyum sağlar.',
            en: 'MO-KA Light Plywood Surface Formwork System, comes forward with its lightness and modular structure. MO-KA Light which has 75mm panel thickness is produced only with galvanize coating, it has 12mm plywood on the surface. This system provides fast assembly and easy portability in the construction sites thanks to being portable both by hand and by crane. The panels can be assembled easily both vertically and horizontally. The system  provides maximum adaptability to all subsequent projects.'
          },
          {
            tr: 'MO-KA Light Plywood Yüzeyli Kalıp Sistemi, dayanıklı ve hafif yapısı ile projelerde hızlı kurulum, esneklik ve verimlilik sunar. Şantiyede hızlı uygulama ve iş gücü tasarrufu sağlayarak, her boyuttaki projede yüksek performans elde edilir.',
            en: 'MO-KA Light Plywood Surface Formwork System offers fast installation, flexibility and efficiency in projects with its durable and lightweight structure. By providing fast assembly and labor savings on the construction site, high performance is achieved in projects of all sizes.'
          }
        ],
        markedText: {
          title: { tr: 'Öne Çıkan Özellikler:', en: 'Key Features:' },
          items: [
            { tr: '✔ Modüler ve Esnek Kullanım: Paneller, dikey ve yatay montaj seçenekleriyle kolayca yerleştirilebilir.', en: '✔ Modular and Flexible Use: Panels can be easily placed with vertical and horizontal assembling options.' },
            { tr: '✔ Hızlı Kurulum: Şantiyeye geldiği andan itibaren montaja hazır olan sistem, ön kurulum gerektirmez.', en: '✔ Fast Installation: The system, which is ready for installation from the moment it arrives at the construction site, does not require pre-installation.' },
            { tr: '✔ Taşıma Kolaylığı: Elle ve vinçle taşınabilir, böylece iş gücü ve zaman tasarrufu sağlar.', en: '✔ Ease of Transport: It can be carried by hand and crane, thus saving labor and time.' }
          ]
        }
      },
      {
        name: { tr: 'MO-KAI Plywood Yüzeyli Kalıp Sistemi', en: 'MO-KAI Plywood Surfaced Formwork System' },
        link: 'mo-kai-plywood-yuzeyli-kalip-sistemi',
        images: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
        text: [
          {
            tr: 'MO-KAI Plywood Yüzeyli Kalıp Sistemi, ultra geniş opsiyonel özellikleri sayesinde farklı kesitler arasında kolayca geçiş yapılmasına olanak tanır. 100 mm panel kalınlığı bulunan MO-KAI Modüler Kalıp sistemi boyalı ve galvanizli üretilmekte olup, yüzeyinde 18 mm Plywood bulunmaktadır. Geniş ölçü seçenekleri ile şantiyede esneklik sunarak, kullanıcıların farklı projelerde verimli ve pratik bir şekilde çalışmasını sağlar.',
            en: 'MO-KAI Plywood Surface Formwork System allows easy transition between different sections thanks to its ultra-wide optional features. MO-KAI Modular Formwork System with 100 mm panel thickness is produced in powder-coating and galvanize-coating and the panels have 18 mm Plywood on their surface. It offers flexibility on the construction site with its wide size options, allowing users to work efficiently and practically in different projects.'
          },
          {
            tr: '4936 çelik çekme özel profilden üretilen sistem çerçevesi, maksimum dayanıklılık ve uzun ömürlü kullanım sunar. Paneller, özel bağlantı aparatları sayesinde hem dikey hem de yatay olarak kolayca monte edilebilir. MO-KAI, farklı projelere de yüksek uyum sağlar. Şantiyeye ulaştığında montaja hazırdır ve ön kurulum gerektirmez.',
            en: 'The system frame produced from 4936 steel extruded special profile offers maximum durability and long-lasting use. Panels can be easily assembled both vertically and horizontally thanks to special connection apparatus. MO-KAI also provides high adaptability to different projects. It is ready for assembly when it reaches the construction site and does not require pre-installation.'
          },
          {
            tr: 'MO-KAI Modüler Kalıp Sistemi, ekstra ölçü seçenekleri sunan plywood yüzeyli panel kalıp sistemidir. Panel yüzeyinde bulunan 5 cm aralıklarla yerleştirilmiş delikler, kolon montajında istenilen ölçülerde delik konumlandırmasına olanak tanır. Sağlam yapısı, yüksek uyumluluğu ve kullanım kolaylığı ile tüm şantiyelerde hızlı ve verimli çözümler sunar.',
            en: 'MO-KAI Modular Formwork System is a plywood surface panel formwork system that offers extra size options. Holes placed at 5 cm intervals on the panel surface allow hole positioning at desired dimensions in column assembly. With its robust structure, high compatibility and ease of use, it offers fast and efficient solutions in all construction sites.'
          }
        ],
        markedText: {
          title: { tr: 'Öne Çıkan Özellikler:', en: 'Key Features:' },
          items: [
            { tr: '✔ Modüler ve Esnek Kullanım: Paneller, dikey ve yatay montaj seçenekleriyle kolayca yerleştirilebilir.', en: '✔ Modular and Flexible Use: Panels can be easily placed with vertical and horizontal assembly options.' },
            { tr: '✔ Hızlı Kurulum: Şantiyeye ulaştığında hemen monte edilebilir, ön kurulum gerektirmez.', en: '✔ Fast Installation: It can be assembled immediately when it reaches the construction site, does not require pre-installation.' },
            { tr: '✔ Geniş Ölçü Seçenekleri: Ultra geniş opsiyonlar sayesinde farklı kesitler arasında kolay geçiş sağlanır.', en: '✔ Wide Size Options: Easy transition between different sections is provided thanks to ultra-wide options.' },
            { tr: '✔ Dayanıklı Yapı: 4936 çelik çekme özel profilden üretilmiş sistem çerçevesi yüksek mukavemet sunar.', en: '✔ Durable Structure: The system frame made of 4936 steel extrusion special profile offers high strength.' }
          ]
        }
      },

      {
        name: { tr: 'MO-KA Plus Plywood Yüzeyli Kalıp Sistemi', en: 'MO-KA PLUS Plywood Surfaced Formwork System' },
        link: 'mo-ka-plus-plywood-yuzeyli-kalip-sistemi',
        images: ['1', '2', '3'],
        text: [
          {
            tr: 'MO-KA PLUS Modüler Kalıp Sistemi, ultra geniş opsiyonel özellikleri sayesinde farklı kesitler arasında kolayca geçiş yapılmasına olanak tanır. 120 mm panel kalınlığı bulunan MO-KAI Modüler Kalıp sistemi boyalı ve galvanizli üretilmekte olup, yüzeyinde 21 mm Plywood bulunmaktadır. Geniş ölçü seçenekleri ile şantiyede esneklik sunarak, kullanıcıların farklı projelerde verimli ve pratik bir şekilde çalışmasını sağlar. Kolon ebatlarının çok yüksek seviyelere çıktığı endüstriyel tesislerin inşaasında kullanılmaktadır.',
            en: 'MO-KA PLUS Modular Formwork System allows easy transition between different sections thanks to its ultra-wide optional features. MO-KAI Modular Formwork system with 120 mm panel thickness is produced in powder-coating and galvanize-coating and the panels have 21 mm Plywood on their surface. It offers flexibility on the construction site with its wide size options, allowing users to work efficiently and practically in different projects. It is used in the construction of industrial facilities where column sizes reach very high levels.'
          },
          {
            tr: '4936 çelik çekme özel profilden üretilen sistem çerçevesi, maksimum dayanıklılık ve uzun ömürlü kullanım sunar. Paneller, özel bağlantı aparatları sayesinde hem dikey hem de yatay olarak kolayca monte edilebilir. MO-KAI, farklı projelere de yüksek uyum sağlar. Şantiyeye ulaştığında montaja hazırdır ve ön kurulum gerektirmez.',
            en: 'The system frame produced from 4936 steel extruded special profile offers maximum durability and long-lasting use. Panels can be easily assembled both vertically and horizontally thanks to special connection apparatus. MO-KA PLUS also provides high adaptability to different projects. It is ready for assembly when it reaches the construction site and does not require pre-installation.'
          },
          {
            tr: 'MO-KAI Modüler Kalıp Sistemi, ekstra ölçü seçenekleri sunan plywood yüzeyli panel kalıp sistemidir. Panel yüzeyinde bulunan 5 cm aralıklarla yerleştirilmiş delikler, kolon montajında istenilen ölçülerde delik konumlandırmasına olanak tanır. Sağlam yapısı, yüksek uyumluluğu ve kullanım kolaylığı ile tüm şantiyelerde hızlı ve verimli çözümler sunar.',
            en: 'MO-KAI Modular Formwork System is a plywood surface panel formwork system offering extra size options. Holes placed at 5 cm intervals on the panel surface allow hole positioning at desired dimensions in column assembly. With its robust structure, high compatibility and ease of use, it offers fast and efficient solutions in all construction sites.'
          }
        ],
        markedText: {
          title: { tr: 'Öne Çıkan Özellikler:', en: 'Key Features:' },
          items: [
            { tr: '✔ Modüler ve Esnek Kullanım: Paneller, dikey ve yatay montaj seçenekleriyle kolayca yerleştirilebilir.', en: '✔ Modular and Flexible Use: Panels can be easily assembled both vertically and horizontally.' },
            { tr: '✔ Hızlı Kurulum: Şantiyeye ulaştığında hemen monte edilebilir, ön kurulum gerektirmez.', en: '✔ Fast Installation: It can be assembled immediately when it reaches the construction site, does not require pre-installation.' },
            { tr: '✔ Geniş Ölçü Seçenekleri: Ultra geniş opsiyonlar sayesinde farklı kesitler arasında kolay geçiş sağlanır.', en: '✔ Wide Range of Size Options: Easy transition between different sections is provided thanks to ultra-wide options.' },
            { tr: '✔ Dayanıklı Yapı: 4936 çelik çekme özel profilden üretilmiş sistem çerçevesi yüksek mukavemet sunar.', en: '✔ Durable Structure: The system frame made of 4936 steel extruded special profile offers high strength.' }
          ]
        }
      },
      {
        name: { tr: 'Dairesel Kalıp Sistemi', en: 'Circular Formwork System' },
        link: 'dairesel-kalip-sistemi',
        images: ['1', '2', '3', '4', '5', '6'],
        text: [
          {
            tr: 'Dairesel kolon Sistemi, çelik kuşaklı olarak üretilmekte olup, iki yarım daire şeklinde tasarlanır. Proje yüksekliği ve çapına göre özel olarak imal edilen bu sistem, pano kilitleri ve özel bağlantı elemanları ile güvenli ve sağlam bir şekilde birleştirilir.',
            en: 'Circular Column System is manufactured with steel supporting belts and is designed in the form of two semicircles. This system, which is specially manufactured according to the project height and diameter, is combined safely and securely with panel locks and special connection elements.'
          },
          {
            tr: 'Yüksek kolon dökümlerinde taze beton basıncına karşı özel kuşaklarla takviye edilen sistem, güvenli ve dayanıklı bir çözüm sunar. Kalıp panelleri, ebatlarına bağlı olarak elle veya vinçle taşınabilir şekilde üretilir. Birleştirildiğinde vinçle taşınarak hızlı ve verimli kolon imalatı yapılmasını sağlar.',
            en: 'The system, which is reinforced with special supporting belts against fresh concrete pressure in high column pourings, offers a safe and durable solution. Formwork panels are manufactured to be carried by hand or by crane, depending on their size. When combined, they are carried by crane and enable fast and efficient column manufacturing.'
          },
          {
            tr: 'Tırmanma konsolları ile entegre edilerek tırmanır kalıp sistemine dönüştürülebilen bu kalıplar, yüksek yapılarda güvenli ve hızlı beton dökümü için ideal bir çözümdür.',
            en: 'These formworks, which can be converted into a climbing formwork system by being integrated with climbing consoles, are an ideal solution for safe and fast concrete pouring in high structures.'
          }
        ]
      },



    ]
  },
  {
    name: { tr: 'DÖŞEME KALIBI SİSTEMLERİ', en: 'SLAB FORMWORK SYSTEMS' },
    svg: 'doseme-kalibi-sistemleri.svg',
    link: 'doseme-kalibi-sistemleri',
    images: ['1', '2', '3', '4'],
    cover: 'cover',
    innerCategory: [
      {
        name: { tr: 'Kalıp Altı İskele Sistemi', en: 'Table Type Scaffolding System' },
        link: 'kalip-alti-iskele-sistemi',
        images: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13'],
        text: [
          {
            tr: 'Kalıp Altı İskele sistemleri, geniş yüzeyli döşemelerin hızlı ve verimli bir şekilde kalıplanmasını sağlar. Yüksek taşıma kapasitesine sahip olan bu sistem, birbirinden bağımsız kuleler halinde kurulabilir ve alt ile üst yapı projelerinde güvenle kullanılabilir. Kuleler arası mesafe tabliye beton yüküne göre değişir.',
            en: 'Table Type Scaffolding systems provide fast and efficient pouring of large surface slabs. This system, which has a high carrying capacity, can be installed as independent towers and can be used safely in infrastructure and superstructure projects. The distance between the towers varies according to the concrete load of the slab.'
          },
          {
            tr: 'H çerçevelerin boru çapı 60 mdir ve kalınlık olarak 3mm - 4mm ve 5mm olarak üretim yapılmaktadır.',
            en: 'The pipe diameter of H frames is 60 mm and is produced in thicknesses of 3 mm - 4 mm and 5 mm.'
          },
          {
            tr: 'Farklı kat yüksekliklerine optimum ölçü uyumu sunan sistem, pozlandığında demonte edilmeden masa taşıma çatalı yardımıyla üst kata taşınabilir. Bu özellik, şantiyede zaman ve iş gücünden tasarruf sağlarken, iş akışını hızlandırır ve verimliliği artırır.',
            en: 'The system, which offers optimum size adaptation to different floor heights, can be carried to the upper floor with the help of a table carrying fork without being disassembled when posed. This feature saves time and labor on the construction site, speeds up the workflow and increases efficiency.'
          },
          {
            tr: 'Dayanıklı yapısı, esnek kullanım imkanı ve hızlı kurulum avantajıyla masa tipi taşıyıcı iskele sistemleri, yüksek verimlilik gerektiren projeler için ideal bir çözümdür.',
            en: 'With its durable structure, flexible use and fast installation advantage, table type scaffolding systems are an ideal solution for projects that require high efficiency.'
          }
        ]
      },
      {
        name: { tr: 'Teleskopik Direk Sistemi', en: 'Telescopic Props System' },
        link: 'teleskopik-direk-sistemi',
        images: ['1', '2', '3', '4'],
        text: [
          {
            tr: 'Teleskopik Direkler özellikle konut ve villa gibi inşaatlarda tabliye ve kiriş altı uygulamalarında kullanılan, farklı yüksekliklere ayarlanabilen destek elemanlarıdır. Ağır Tip ve Eko Tip olmak üzere iki farklı modelde üretilir.',
            en: 'Telescopic Props are support elements that can be adjusted to different heights, especially used in slab and beam pourings in constructions such as residences and villas. They are produced in two different models: Heavy Type and Eco Type.'
          },
          {
            tr: 'Eko Tip Teleskopik Direkler: 3 - 3,5 - 4 metre yükseklik seçenekleriyle üretilir.',
            en: 'Eco Type Telescopic Poles: They are produced with 3 - 3.5 - 4 meter height options.'
          },
          {
            tr: 'Ağır Tip Teleskopik Direkler: 3 - 3,5 - 4 - 4,5 - 5 metre yükseklik seçenekleriyle üretilir.',
            en: 'Heavy Type Telescopic Poles: They are produced with 3 - 3.5 - 4 - 4.5 - 5 meter height options.'
          },
          {
            tr: 'Teleskopik direkler, kullanım alanına göre T Başlık, Atkı Başlık, Düz Başlık ve 10x10 Başlık olmak üzere dört farklı başlık seçeneğiyle üretilmektedir. Sağlam yapısı ve ayarlanabilir özelliği sayesinde her türlü inşaat projesinde güvenli ve verimli bir destek çözümü sunar.',
            en: 'Telescopic props are produced with four different head options, namely T Head, 10x12 Head, Flat Head and 10x10 Head, depending on the area of ​​use. Thanks to its robust structure and adjustable feature, it offers a safe and efficient support solution in all types of construction projects.'
          }
        ],
        markedText: {
          title: { tr: 'Malzeme özellikleri:', en: 'Material features:' },
          items: [
            {
              tr: '✔ Ağır Tip Teleskopik Direkler: İç boru: 48x3 mm, dış boru: 60x2,5 mm',
              en: '✔ Heavy Type Telescopic Poles: Inner tube: 48x3 mm, outer tube: 60x2.5 mm'
            },
            {
              tr: '✔ Eko Tip Teleskopik Direkler: İç boru: 48x2,5 mm, dış boru: 60x2 mm',
              en: '✔ Eco Type Telescopic Poles: Inner tube: 48x2.5 mm, outer tube: 60x2 mm'
            }
          ]
        }
      },
      {
        name: { tr: 'Döşeme Panosu Sistemi', en: 'Slab Panel System' },
        link: 'doseme-panosu-sistemi',
        images: ['1', '2', '3'],
        text: [
          {
            tr: 'Döşeme panoları, geleneksel kalıp yönteminde hızlı sarfiyatı olan plywoood benzeri malzemeler yerine tamamen ST37 kalite siyah sacdan üretilmektedir. Bu sayede sarfiyatı düşük ve uzun ömürlüdür. Tüm inşaat projelerinde güvenli ve dayanıklı bir kalıp çözümü sunar.',
            en: 'Slab formwork panels are manufactured entirely from ST37 (S235JR) grade sheet metal instead of plywood-like materials that are quickly consumed in the traditional formwork method. In this way, they have low waste and the panels are long-lasting. They offer a safe and durable formwork solution in all construction projects.'
          },
          {
            tr: 'Düz yüzeyli olup, 2mm kalınlığında sac malzemeden üretilmiştir.',
            en: 'They have a flat surface and are manufactured from 2 mm thick sheet metal.'
          },
          {
            tr: 'Boyuna iki adet kuşak ile güçlendirilmiş sağlam bir yapıya sahiptir.',
            en: 'They have a solid structure reinforced with two longitudinal supporting belts.'
          },
          {
            tr: 'Üç kıvrımlı kenar tasarımı, dayanıklılığı artırırken uzun ömürlü kullanım sağlar.',
            en: 'The three-curved edge design increases durability and provides long-lasting use.'
          },
          {
            tr: 'Dört köşesinde çift çivi delikleri bulunarak, montaj kolaylığı sunar.',
            en: 'They offer ease of assembly with double nail holes on four corners.'
          },
          {
            tr: 'Standart ölçüsü 50 x 100 cm olmakla birlikte, projeye özel farklı uzunluk ve genişlikte üretim yapılabilmektedir.',
            en: 'Although the standard size is 50 x 100 cm, production can be made in different lengths and widths specific to the project.'
          },
          {
            tr: 'Yüksek mukavemetli yapısı ve esnek ölçü seçenekleriyle döşeme panoları, güvenli ve pratik bir kalıp çözümü sunarak şantiye verimliliğini artırır.',
            en: 'With their high-strength structure and flexible size options, slab formwork panels increase construction site efficiency by providing a safe and practical formwork solution.'
          }
        ]
      },

      {
        name: { tr: 'Kiriş Tabanı - Tabliye Atkısı Sistemi', en: 'Beam Bottom - Steel Grid of Slab System' },
        link: 'kiris-tabani-tabliye-atkisi-sistemi',
        images: ['1', '2', '3', '4', '5', '7', '8', '9'],
        text: [
          {
            tr: 'Kiriş tabanları, iki kolon arasındaki mesafeyi istenilen ölçüde kapatarak güvenli ve pratik bir kalıp çözümü sunar. Sistem, dış ve iç sürgülü sac malzemeden oluşur ve ölçü değişkenliği sayesinde her projeye uyum sağlar.',
            en: 'Beam bottoms offer a safe and practical formwork solution by closing the distance between two columns to the desired extent. The system consists of external and internal sliding sheet metal and adapts to every project thanks to its variable dimensions.'
          },
          {
            tr: 'Standart üretim eni 25 cm olup, 20 cm ve 30 cm genişlikte de üretilebilmektedir.',
            en: 'The standard production width is 25 cm, and it can also be produced in 20 cm and 30 cm widths.'
          },
          {
            tr: '75 - 100 - 125 - 150 - 200  - 250 - 300 cm ölçülerinde üretilmekte olup, kızaklı sistem sayesinde sırasıyla maksimum 130 - 180 - 230 - 280 - 380 - 480 - 580 cm uzunluğa kadar açılabilir.',
            en: 'It is produced in 75 - 100 - 125 - 150 - 200 - 250 - 300 cm dimensions, and thanks to the sliding system, it can be opened up to a maximum length of 130 - 180 - 230 - 280 - 380 - 480 - 580 cm respectively.'
          },
          {
            tr: 'Her 25 cm aralıkta çivi deliği bulunur, bu sayede montaj kolaylığı sağlanır.',
            en: 'There is a nail hole at every 25 cm interval, thus it enables easy assembly.'
          },
          {
            tr: 'Ayar mekanizması ile ölçü alındıktan sonra vida sıkılarak sabitlenir. Kızaklı sistem sayesinde esnek ölçü ayarı yapılabilir, böylece farklı projelerde rahatlıkla kullanılabilir. Sağlam yapısı, kolay montajı ve esnek kullanım avantajları ile kiriş tabanları, hızlı ve güvenilir bir kalıp çözümü sunar.',
            en: 'After the measurement is taken with the adjustment mechanism, the screw is tightened and fixed.Thanks to the sliding system, flexible measurement adjustment can be made, thus it can be easily used in different projects.'
          },
          {
            tr: 'Tabliye atkısı, inşaatlarda döşeme kalıbı kurulumunda mahya ve ızgara yerine kullanılan pratik ve dayanıklı bir çözümdür. Dış ve iç sürgülü sac malzemeden oluşan sistem, farklı projelere uyum sağlayacak şekilde tasarlanmıştır.',
            en: 'The steel grid of slabs are a practical and durable solution used instead of ridge and grid in the installation of slab formwork in construction. The system, which consists of external and internal sliding sheet material, is designed to adapt to different projects.'
          },
          {
            tr: 'Her iki ucundaki köşebentler, çivi ile iç kanada montajlanır.',
            en: 'The brackets at both ends are mounted to the inner beams with nails.'
          },
          {
            tr: 'Tabliye atkısı kullanıldığında, taşıyıcı teleskopik direkler 100 - 120 cm aralıklarla kurulmaktadır.',
            en: 'When the steel grid of slab is used, the carrier telescopic props are installed at intervals of 100 - 120 cm.'
          },
          {
            tr: '150 - 200 - 250 - 300 cm ölçülerinde üretilmekte olup, kızaklı sistem sayesinde sırasıyla maksimum 280 - 380 - 480 - 580 cm uzunluğa kadar açılabilir.',
            en: 'It is produced in sizes of 150 - 200 - 250 - 300 cm and can be opened to a maximum length of 280 - 380 - 480 - 580 cm respectively thanks to the sliding system.'
          },
          {
            tr: 'Kızaklı sistemin sunduğu ölçü değişkenliği, farklı projelere uyumlu kullanım imkanı sağlar.',
            en: 'The size variability offered by the sliding system provides the opportunity for compatible use with different projects.'
          },
          {
            tr: 'Sağlam yapısı, esnek ölçü seçenekleri ve kolay montaj özelliği ile tabliye atkısı, hızlı ve verimli döşeme kalıp sistemleri için ideal bir çözümdür.',
            en: 'With its robust structure, flexible size options and easy assembly feature, the deck railing is an ideal solution for fast and efficient floor formwork systems.'
          }
        ]
      },

    ]
  },
  {
    name: { tr: 'ÖZEL TASARIMLAR', en: 'SPECIAL DESIGNS' },
    svg: 'ozel-tasarimlar.svg',
    link: 'ozel-tasarimlar',
    images: [],
    cover: 'cover',
    innerCategory: [
      {
        name: { tr: 'Düz - Desenli Bahçe Kalıpları', en: 'Flat - Patterned -  Garden Wall Formworks' },
        link: 'duz-desenli-bahce-kaliplari',
        images: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11'],
        text: [
          {
            tr: 'Bahçe Kalıpları, inşaası devam eden yada tamamlanmış olan yapıların çevresini kapatmak için kullanılır. Karo, Pencere, Motif, Briket, Baklava, Oyma, Kabartma Göbek vb. desenlerde ve düz desenli olarak üretimi yapılabilmektedir.',
            en: 'Garden Wall Formworks are used to cover the surroundings of construction works that are under construction or have been completed. They can be produced in patterns such as Tile, Window, Motif, Briquette, Diamond, Carving, Embossed Core etc. and flat patterns'
          }
        ]
      },

      {
        name: { tr: 'Merdiven Kalıpları', en: 'Stair Formworks' },
        link: 'merdiven-kaliplari',
        images: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11'],
        text: [
          {
            tr: 'Merdiven Kalıpları, inşaatlarda en çok zaman ve malzeme sarfiyatının yapıldığı kalıplardır. Her katta sarfiyat artarak devam eder. Projeye özel ürettiğimiz Merdiven Kalıpları, projeye özel hazırlanan kurulum şemaları ile birlikte sorunsuz ve hızlı kurulum yapılmasını sağlar.',
            en: 'Stair Formworks are the formworks where the most time and material consumption is made in construction. The consumption continues while reaching to the upper floors. Staircase Formworks that we produce specifically for the project, together with the installation schemes prepared specifically for the project, ensure a problem-free and fast installation.'
          },
          {
            tr: 'Sahanlıklı, sahanlıksız, düz, dairesel, düz basamaklı, özel basamaklı, merdiven altı düz, merdiven altı ters basamaklı gibi farklı tasarımlara özel üretim yapılabilmektedir.',
            en: 'Different designs such as landing, non-landing, flat, circular, flat step, special step, flat under the stairs, reverse step under the stairs can be specially produced.'
          }
        ]
      },

      {
        name: { tr: 'RES Rüzgar Enerji Santrali Kalıpları', en: 'WPP Wind Power Pland Formworks' },
        link: 'res-ruzgar-enerji-santrali-kaliplari',
        images: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
        text: [
          {
            tr: 'Türkiye, coğrafi konumu itibarıyla yüksek rüzgâr enerjisi potansiyeline sahip bir ülkedir. Bu nedenle, özellikle rüzgâr potansiyelinin yüksek olduğu bölgelerde rüzgar enerji santralleri hızla yaygınlaşmakta ve çok sayıda işletme faaliyete geçmektedir.',
            en: 'Turkey is a country with high wind energy potential due to its geographical location. For this reason, wind power plants are rapidly spreading and many businesses are starting operations, especially in regions where wind potential is high.'
          },
          {
            tr: 'Şirketimiz, rüzgâr türbini çiftliklerinde kullanılan temel kalıpları ile şantiyelerin hızlı rotasyonuna destek sağlamaktadır. Projeye özel olarak her çap ve yükseklikte imalat yapabilmekteyiz.',
            en: 'Our company supports the rapid rotation of construction sites with foundation formworks used in wind turbine farms. We can manufacture in any diameter and height specific to the project.'
          },
          {
            tr: 'Boğaz Kalıbı Çözümü:Boğaz kalıbı uygulamalarında, geleneksel yöntemlerde temel beton dökümü öncesinde donatı demiri ile kalıp arasında ağaç veya başka bir malzeme kullanılarak irtibat kesilir. Ancak bu yöntem, kalıbın terazide düzgün durmasını zorlaştırır.',
            en: 'Throat Formwork Solution In throat formwork applications, in traditional methods, the connection between the reinforcement bar and the formwork is cut off using wood or another material before the foundation concrete is poured. However, this method makes it difficult for the concrete to stand properly on the scale.'
          },
          {
            tr: 'Bu sorunu önlemek için, görsellerde de gösterildiği gibi özel bir konstrüksiyon tasarımı ile boğaz kalıbı askıya alınabilir. Böylece, kalıbın alttaki donatı demiriyle teması tamamen kesilerek, daha stabil ve hassas bir montaj sağlanır.',
            en: 'In order to prevent this problem, the throat formwork can be suspended with a special construction design as shown in the images. Thus, the contact of the concrete with the reinforcement bar below is completely cut off, providing a more stable and precise assembly.'
          }
        ]
      },
      {
        name: { tr: 'Soket - Prekast Kalıpları', en: 'Socket - Precast Formworks' },
        link: 'soket-prekast-kaliplari',
        images: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11'],
        text: [
          {
            tr: 'Fabrika ortamında prekast olarak dökülen kolon betonları, şantiye sahasına geldikten sonra önceden oluşturulan soketlere dikey olarak monte edilir. Bu soketlerin doğru ve hassas bir şekilde oluşturulabilmesi için çeşitli çelik kalıp sistemleri sunmaktayız.',
            en: 'Column concretes, which are precast in the factory environment, are inserted vertically in the sockets created in advance after arriving at the construction site. We offer various steel formwork systems so that these sockets can be created accurately and precisely.'
          },
          {
            tr: 'Sistem, iç kalıp ve dış kalıp olmak üzere iki ana bileşenden oluşur ve istenilen yükseklik ve ölçüde üretim yapılabilmektedir. Düz Yüzeyli üretilmesinin yanı sıra fugalı olarak da üretim yapılabilmektedir.',
            en: 'The system consists of two main components, inner formwork and outer formwork, and can be produced in the desired height and size. In addition to being produced with a flat surface, it can also be produced with a gap.'
          },
          {
            tr: 'İç Kalıp:Dört iç köşe paneli ve dört orta panelden oluşur. İç soket ölçüsü sabittir, daraltma yapılamaz. Ölçü değişikliği için ek parça kullanılabilir.Yükseklikler projeye özel olarak üretilir.',
            en: 'Inner Formwork It consists of four inner corner panels and four middle panels. The inner socket size is assembled, it cannot be narrowed. Additional parts can be used for size changes. Heights are produced specifically for the project.'
          },
          {
            tr: 'Dış Kalıp Genellikle tek parça olarak üretilir. Yan kenarlarda bulunan 4+4 delik sayesinde soket dış ölçüsü daraltılıp genişletilebilir. Ekstra takviye kuşağına gerek duyulmaz. Parçalı olarak üretilebilen modellerde, takviye kuşağı kullanılması gerekmektedir. Sağlam ve esnek ölçü seçenekleriyle kullanıcının şantiyede gereksinimlerini karşılayan kalıp sistemlerimiz, projelerinizde güvenilir ve verimli bir çözüm sunar.',
            en: 'Outer Formwork It is usually produced in one piece. Thanks to the 4+4 holes on the side edges, the outer socket size can be narrowed and widened. Extra reinforcement belt is not required. In models that can be produced in parts, reinforcement belts must be used.Our formwork systems, which meet the users needs on the construction site with their robust and flexible size options, offer a reliable and efficient solution for your projects.'
          }
        ]
      },
      {
        name: { tr: 'Askerli Çelik Kalıp Sistemi', en: 'Steel Formwork with Soldier System' },
        link: 'askerli-celik-kalip-sistemi',
        images: ['0', '1', '2', '3', '4', '5', '6', '7', '8'],
        text: [
          {
            tr: 'Askerli çelik kalıp sistemi, yüksek duvar betonlarının tek seferde dökülmesinin maliyetli olduğu durumlarda, kalıbın tırmandırılarak kullanıldığı verimli bir çözümdür. İnsan gücüyle kolayca kurulabilen bu sistem, gerektiğinde vinçle taşımaya da uygundur.',
            en: 'The Soldier Type steel formwork system is an efficient solution where the formwork is used by climbing in cases where pouring high wall concrete in one go is costly. This system, which can be easily installed with manpower, is also suitable for transportation by crane when necessary.'
          },
          {
            tr: 'Sistemin tırmanma mekanizması, yalnızca askerler üzerinden geçirilen tie-rodlar ile sağlanır. Bu sayede kalıp, borulu askerler üzerinde yukarı doğru kademeli olarak hareket ettirilerek tırmandırılır. 3 metreye kadar istenilen ölçülerde üretilebilen bu sistem, güvenli ve ekonomik bir uygulama sunar.',
            en: 'formwork is gradually moved upwards on the pipe soldiers and climbed. This system, which can be produced in desired dimensions up to 3 meters, offers a safe and economical application.'
          }
        ]
      },
      {
        name: { tr: 'Düz - Dairesel Balkon / Parapet Kalıpları', en: 'Flat - Circular Balcony - Paraphet Formworks' },
        link: 'dairesel-balkon-parapet-kaliplari',
        images: ['1', '2', '3', '4', '5', '6', '7', '8', '9'],
        text: [
          {
            tr: 'Düz - Dairesel Balkon / Parapet Kalıpları, yapıların hem estetik hem de fonksiyonel unsurlarından biridir. Geleneksel parapetlerden farklı olarak, mimari tasarım odaklı parapetler, güvenliği sağlarken yapının genel estetiğini tamamlayacak şekilde özel olarak tasarlanır.',
            en: 'Flat - Circular Balcony / Paraphet Formworks are one of the aesthetic and functional elements of structures. Unlike traditional paraphets, architectural design-oriented paraphets are specially designed to complement the general aesthetics of the structure while ensuring safety.'
          },
          {
            tr: 'Mimari balkon ve parapetleri, yalnızca görsel açıdan değil, aynı zamanda hava koşullarına ve dış etkenlere karşı dayanıklılık, uzun ömürlülük ve yüksek kalite standartları açısından da üstün niteliklere sahip olmalıdır. Gökdelen İskele Kalıp olarak, mimari tasarımın ön planda olduğu projeler için özel olarak üretilmiş balkon ve parapet kalıplarıyla güvenilir ve estetik çözümler sunuyoruz. Yapıya özel tasarlanmış kalıplarımız sayesinde, projelerinize hem işlevsellik hem de estetik değer katıyoruz.',
            en: 'Architectural balconies and parapets should have superior qualities not only in terms of visuality, but also in terms of resistance to weather conditions and external factors, longevity and high quality standards.As Gökdelen İskele Kalıp, we offer reliable and aesthetic solutions with specially produced balcony and paraphet formworks for projects where architectural design is at the forefront. Thanks to our formworks specially designed for the structure, we add both functionality and aesthetic value to your projects.'
          }
        ]
      },
      {
        name: { tr: 'Diğer İmalatlar', en: 'Other Productions' },
        link: 'diger-imalatlar',
        images: ['1', '2', '3', '4', '5'],
        text: [
          { tr: '', en: '' }
        ]
      },




    ]
  }
];
